import { Button, Modal, Row, Space } from 'antd';
import React from 'react';

export interface SubmitConfirmProps {
  visible: boolean;
  title: string;
  onSubmitConfirm: () => void;
  onCancelConfirm: () => void;
}

export const SubmitConfirm = ({
  visible,
  title,
  onSubmitConfirm,
  onCancelConfirm,
}: SubmitConfirmProps) => {
  return (
    <Modal
      width={700}
      visible={visible}
      onOk={onSubmitConfirm}
      onCancel={onCancelConfirm}
      centered
      footer={null}
    >
      <Row justify="center" gutter={[16, 24]}>
        <Row justify="center">
          <div
            style={{
              fontWeight: 'bolder',
              fontSize: 17,
              textAlign: 'center',
              marginTop: 20,
              marginBottom: 20,
            }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </Row>
        <Row justify="center" align="middle">
          <Space>
            <Button
              htmlType="button"
              style={{ color: '#568FFF' }}
              onClick={onSubmitConfirm}
            >
              Yes
            </Button>
            <Button htmlType="button" onClick={onCancelConfirm}>
              No
            </Button>
          </Space>
        </Row>
      </Row>
    </Modal>
  );
};
